

































































































































































































































import { defineComponent, reactive, ref, watch } from "@vue/composition-api";
import { displayRequestStatus } from "@/notifications";
import { Button } from "@micad/vue-components/src/main";
import Loading from "@/components/Loading.vue";
import { App } from "@/interfaces/common.interfaces";
import {
  addTerm,
  delTerm,
  editTerm,
  getTerms,
  deleteTermsAgreed,
  Term,
  updateTerms,
} from "@/data/repos/termsAndConditions";
import {
  SelectOption,
  TableColumn,
} from "@micad/vue-components/src/common/interfaces";
import { find } from "lodash";
import ModalContainer from "@/components/ModalContainer.vue";
import { InputContainer, SearchableSelect } from "@micad/vue-components";
import { ApiResponse } from "@/data/apiClient";
import { getApps } from "@/data/repos/apps";
import { canIUse } from "@/modules/auth";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Array<T> {
    swap(a: number, b: number): void;
  }
}

Array.prototype.swap = function (a: number, b: number) {
  if (a < 0 || a >= this.length || b < 0 || b >= this.length) return;
  const temp = this[a];
  this[a] = this[b];
  this[b] = temp;
};

const columns: TableColumn[] = [
  {
    name: "title",
    label: "Title",
    align: "left",
    field: (row: Term) => row.title,
    classes: "primary",
    sortable: true,
    showMobile: "",
  },
  {
    name: "text",
    label: "Terms & Conditions",
    align: "left",
    field: (row: Term) => row.text,
    classes: "primary td-text",
    sortable: true,
    showMobile: "",
  },
  {
    name: "author",
    label: "Author",
    align: "left",
    field: (row: Term) => row.author,
    classes: "primary",
    sortable: true,
    showMobile: "",
  },
  {
    name: "buttons",
    label: "",
    align: "left",
    field: (row: Term) => row,
    classes: "primary",
    sortable: false,
    showMobile: "",
  },
];

function customSort(rows: TableColumn[], sortBy: string, descending: boolean) {
  const data = [...rows];

  const column = find(
    columns,
    (c: TableColumn) => c.name == sortBy
  ) as TableColumn;

  if (column && column.sortable && sortBy) {
    data.sort((a, b) => {
      const x = descending ? b : a;
      const y = descending ? a : b;

      let sortByX = column.field(x);
      let sortByY = column.field(y);

      sortByX = String(sortByX).toLowerCase();
      sortByY = String(sortByY).toLowerCase();
      // string sort
      return sortByX > sortByY ? 1 : sortByX < sortByY ? -1 : 0;
    });
  }

  return data;
}

export default defineComponent({
  methods: { canIUse },
  components: {
    Button,
    Loading,
    ModalContainer,
    InputContainer,
    SearchableSelect,
  },
  setup() {
    const table = ref(null);
    const showNewDialog = ref(false);
    let terms = reactive([] as Term[]);
    const state = reactive({
      table,
      showNewDialog,
      resetDialogVisible: false,
      showPreviewDialog: false,
      max: 1,
      columns,
      loaded: false,
      app: "IPR",
      apps: [] as App[],
      appOptions: [] as SelectOption[],
      data: terms,
      newTNC: {} as Term,
      newTNCapp: {} as SelectOption,
      tableKey: 0,
      pagination: {
        rowsPerPage: 5,
      },
      isTopRow: (row: Term) => terms.indexOf(row) === 0,
      isBottomRow: (row: Term) => terms.indexOf(row) === terms.length - 1,
      moveUp: async (row: Term) => {
        state.data.swap(terms.indexOf(row), terms.indexOf(row) - 1);
        state.tableKey++;
        await updateTerms(state.data, state.app);
      },
      moveDown: async (row: Term) => {
        state.data.swap(terms.indexOf(row), terms.indexOf(row) + 1);
        state.tableKey++;
        await updateTerms(state.data, state.app);
      },
      addTermsAndConditions: async () => {
        state.loaded = false;
        let resp: ApiResponse<string>;
        if (state.newTNC.id !== undefined) {
          resp = await editTerm(state.newTNC, state.newTNCapp.value);
          displayRequestStatus(resp, "Term has been updated");
        } else {
          resp = await addTerm(state.newTNC, state.newTNCapp.value);
          displayRequestStatus(resp, "Term has been added");
        }
        if (resp.ok) {
          await fetchTerms(state.app);
          state.closeNewDialog();
        }
        state.loaded = true;
      },
      delTerm: async (term: Term) => {
        state.loaded = false;
        const resp = await delTerm(term, state.app);
        displayRequestStatus(resp, "Term has been deleted");
        if (resp.ok) await fetchTerms(state.app);
        state.loaded = true;
      },
      editingTerm: false,
      editTerm: (term: Term) => {
        Object.assign(state.newTNC, term);
        setCurrentAppOption(state.app);
        state.editingTerm = true;
        state.showNewDialog = true;
      },
      customSort,
      closeNewDialog: () => {
        state.newTNC = {} as Term;
        state.showNewDialog = false;
      },
      showAddTNCDialog: () => {
        state.newTNC = {} as Term;
        state.showNewDialog = true;
      },
      showResetDialog: () => {
        state.resetDialogVisible = true;
      },
      onResetDialog: async () => {
        const resp = await deleteTermsAgreed(state.app);
        displayRequestStatus(
          resp,
          "User agreed flags deleted",
          "Failed to delete user agreed flags"
        );
        state.resetDialogVisible = false;
      },
    });

    async function fetchTerms(app: string) {
      if (!app) return;
      state.loaded = false;
      const resp = await getTerms(app, false);
      displayRequestStatus(resp, "", "Failed to load terms and conditions");
      if (resp.ok) {
        terms.splice(0, terms.length);
        terms.push(...(resp.payload || []));
      }
      state.loaded = true;
    }
    function setCurrentAppOption(app: string) {
      const selectedApp = state.apps.find((v) => v.id === app);
      if (selectedApp)
        state.newTNCapp = { value: selectedApp.id, label: selectedApp.title };
    }
    watch(
      () => state.app,
      (app: string) => {
        fetchTerms(app);
        setCurrentAppOption(app);
      },
      { immediate: true }
    );
    setTimeout(async () => {
      state.apps = [
        //{ id: "", title: "Default" },
        ...((await getApps()).payload || []),
      ];
      state.appOptions = state.apps.map((o: App) => ({
        label: o.title,
        value: o.id,
      }));
    }, 0);
    return state;
  },
});
